import React from "react";

const faqItems = [
  {
    question: "What data does the model use?",
    answer:
      "The model is based on all competitive matches since 2023, covering major and minor leagues worldwide.",
  },
  {
    question: "Does Drafter follow the meta?",
    answer:
      "Yes. The weight of each interaction is proportional to how recent the data is, so the model naturally adapts to the current meta.",
  },
  {
    question: "How are off-meta picks handled?",
    answer:
      "Unlike the previous version of Drafter which used Solo Queue approximations, Drafter.one only considers champions played in competitive. A champion with few or no competitive appearances will have very little impact on the draft: neither positive nor negative, simply transparent.",
  },
  {
    question: "Does Drafter account for side (blue/red)?",
    answer:
      "No. For readability and gameplay balance, the model does not take side into account.",
  },
];

function FAQ() {
  return (
    <section className="FAQ">
      <h2 className="faqTitle">Frequently Asked Questions</h2>
      <div className="faqList">
        {faqItems.map((item) => (
          <div key={item.question} className="faqItem">
            <h3 className="faqQuestion">{item.question}</h3>
            <p className="faqAnswer">{item.answer}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FAQ;
